import { render, staticRenderFns } from "./T1FooterTourops.vue?vue&type=template&id=31f19f65&scoped=true&"
var script = {}
import style0 from "./T1FooterTourops.vue?vue&type=style&index=0&id=31f19f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f19f65",
  null
  
)

export default component.exports